export default __webpack_public_path__ + "static/media/CNo.21-0.bdffd7a6.jpg";